<template>
  <div>
    <v-dialog v-model="errorDialog" width="500">
      <v-card>
        <v-card-title>
          <span>{{ tip }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn
            color="primary"
            flat
            @click="
              errorDialog = false;
              tip = '';
            "
          >
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container class="app-breadcrumbs-container">
      <v-breadcrumbs class="app-breadcrumbs" :items="breadcrumbs">
        <v-icon slot="divider">chevron_right</v-icon>
        <template slot="item" slot-scope="props">
          <router-link
            :to="props.item.to"
            :class="[
              props.item.disabled && 'v-breadcrumbs__item--disabled',
              'app-breadcrumbs__item'
            ]"
          >
            {{ props.item.text }}
          </router-link>
        </template>
      </v-breadcrumbs>
    </v-container>
    <div class="main-title">
      <v-container fill-height>
        <v-layout align-center>
          {{ $t("checkout.your_order_title") }}
        </v-layout>
      </v-container>
    </div>

    <!-- begin 只支持到店取餐 提示 -->
    <div class="takeaway-tip" v-if="storeInfo.takeawayStatus == 2">
      {{ storeInfo.closeShipReminder }}
    </div>
    <!-- end 只支持到店取餐 提示 -->

    <v-container>
      <v-layout justify-center :column="breakpoint.mdAndDown">
        <v-flex xs6 class="address-flex">
          <div v-if="deliveryType == 1">
            {{ $t("checkout.address_tip") }}
          </div>
          <address-list
            is-selection
            v-model="addressGuid"
            create-success-redirect-type="back"
            edit-success-redirect-type="back"
            :show-detail="deliveryType == 0"
          />
        </v-flex>
        <v-flex xs6>
          <v-tabs @change="changeDeliveryType" :value="deliveryType">
            <v-tab
              v-show="storeInfo.takeawayStatus == 1"
              style="text-transform: unset"
            >
              <v-icon
                center
                color="#1867c0"
                v-if="deliveryType == 0"
                style="margin-right: 5px"
                >done
              </v-icon>
              {{ $t("delivery.home_delivery") }}
            </v-tab>
            <v-tab style="text-transform: unset">
              <v-icon
                center
                color="#1867c0"
                v-if="deliveryType == 1"
                style="margin-right: 5px"
                >done
              </v-icon>
              {{ $t("delivery.pick_up") }}
            </v-tab>
          </v-tabs>
          <div class="new_choose_box" v-if="storeInfo.isDeliveryTime == true">
            <div class="left_box">{{ $t("newAdd.add1") }}</div>
            <div class="right_box">
              <div class="selectItem_box" @click="chooseBox(chooseBoxShow)">
                <span v-show="!deliveryDate">{{ $t("unClass.add394") }}</span>
                <!--                <span v-show="isShow == false">{{ chooseHourNum }}:{{ chooseMinuteNum }}</span>-->
                <span v-show="!!deliveryDate">{{ deliveryDate }}</span>
                <img
                  class="xiala_icon"
                  v-show="chooseBoxShow == false"
                  src="../../assets/new_shangla.png"
                  alt=""
                />
                <img
                  class="xiala_icon"
                  v-show="chooseBoxShow == true"
                  src="../../assets/new_xiala.png"
                  alt=""
                />
              </div>
              <div class="selectItem_show_box" v-show="chooseBoxShow == true">
                <div class="top" @click="chooseMinute('')">
                  {{ $t("unClass.add394") }}
                </div>
                <div class="bottom" style="margin-top: 20px;">
                  <date-picker
                    v-model="deliveryDate"
                    valueType="format"
                    :disabled-date="disabledDate"
                    :disabled-time="disabledTime"
                    :placeholder="$t('unClass.add403')"
                    @change="sureDeliveryDate"
                    :lang="languageList[language] || languageList['english']"
                    ref="picker"
                    type="datetime"
                    format="YYYY-MM-DD HH:mm"
                  ></date-picker>
                  <!--                  <div class="left_hour">-->
                  <!--                    <div-->
                  <!--                      class="hour"-->
                  <!--                      v-for="(item, index) in validDateTimeList"-->
                  <!--                      :key="index"-->
                  <!--                    >-->
                  <!--                      <div-->
                  <!--                        class="may_choose"-->
                  <!--                        :class="chooseHour == index ? 'active_may_choose' : ''"-->
                  <!--                        @click="chooseHours(index, item.hour)"-->
                  <!--                      >-->
                  <!--                        <span v-if="item.hour < 10">0</span>{{ item.hour }}-->
                  <!--                      </div>-->
                  <!--                      &lt;!&ndash;                      <div class="no_choose" v-if="item.isQuantum==false">&ndash;&gt;-->
                  <!--                      &lt;!&ndash;                        <span v-if="item.time<10">0</span>{{item.time}}&ndash;&gt;-->
                  <!--                      &lt;!&ndash;                      </div>&ndash;&gt;-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                  <div class="right_minute">-->
                  <!--                    <div-->
                  <!--                      class="minute"-->
                  <!--                      v-for="(item, index) in minute"-->
                  <!--                      :key="index"-->
                  <!--                      @click="chooseMinute(item)"-->
                  <!--                    >-->
                  <!--                      <div class="may_choose">-->
                  <!--                        <span v-show="item < 10">0</span>-->
                  <!--                        <span>{{ item }}</span>-->
                  <!--                      </div>-->
                  <!--                      &lt;!&ndash;                      <div class="no_choose" v-if="chooseHour == active_time_hour&&active_time_minute+30>item">&ndash;&gt;-->
                  <!--                      &lt;!&ndash;                        <span v-show="item<10">0</span>{{item}}&ndash;&gt;-->
                  <!--                      &lt;!&ndash;                      </div>&ndash;&gt;-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                </div>
              </div>
            </div>
            <div style="clear: both"></div>
          </div>
          <div class="your-order-container">
            <div class="your-order-title">
              {{ $t("checkout.your_order_title") }}
            </div>
            <table class="order-table">
              <tr class="order-table-head">
                <th width="50%">{{ $t("checkout.product_head") }}</th>
                <th width="50%">{{ $t("checkout.total_head") }}</th>
              </tr>

              <tr>
                <td colspan="2">
                  <table
                    v-for="(item, index) in cart.items"
                    :key="index"
                    class="order-item-container"
                  >
                    <tr class="order-item">
                      <td>
                        {{
                          (item.delivery &&
                            item.delivery.commodity_name_json &&
                            item.delivery.commodity_name_json[
                              getTranslateIndex
                            ]) ||
                            item.delivery.name
                        }}
                        <strong class="num">× {{ item.num }}</strong>
                        <div class="description">
                          {{ item.remark }}
                        </div>
                        <span
                          v-for="(attr_item, index) in item.delivery.attributes"
                          :key="index"
                        >
                          <span
                            v-if="attr_item.check"
                            style="padding-right: 6px; white-space: nowrap;font-size: 12px;color: #e91f1f;"
                            >{{ attr_item.name }}
                            <span
                              v-if="attr_item.price && Number(attr_item.price)"
                              >€ {{ attr_item.price }}</span
                            >
                          </span>
                        </span>
                      </td>
                      <td class="price">
                        €{{
                          (item.num * parseFloat(item.delivery.takeawayPrice))
                            | fixed(2, true)
                        }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        item.garnish_items && item.garnish_items.length != 0
                      "
                    >
                      <td colspan="2">
                        <div class="garnish-container">
                          <v-layout>
                            <v-flex xs11>
                              <div
                                class="garnish-item"
                                v-for="(garnish_item,
                                garnish_index) in item.garnish_items"
                                :key="garnish_index"
                              >
                                <div class="name">
                                  {{ garnish_item.commodity_name }}
                                </div>
                                <div class="split"></div>
                                <div class="price">
                                  €{{
                                    garnish_item.price ||
                                      garnish_item.commodity_price
                                  }}
                                </div>
                              </div>
                            </v-flex>
                          </v-layout>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr>
                <td>
                  <strong>{{ $t("checkout.subtotal") }}</strong>
                </td>
                <td>
                  <strong class="price">€{{ total | fixed(2, true) }}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>{{ $t("checkout.discount") }}</strong>
                </td>
                <td>
                  <strong class="price"
                    >€-{{ discountAmount | fixed(2, true) }}</strong
                  >
                </td>
              </tr>
              <tr v-show="deliveryType == 0">
                <td>
                  <strong>{{ $t("checkout.delivery_fee") }}</strong>
                </td>
                <td>
                  <strong class="price">€{{ new_DeliveryFee }}</strong>
                </td>
                <!-- <td>€{{ deliveryFee.DeliveryFee | fixed(2, true) }}</td> -->
              </tr>
              <tr class="remark-container">
                <td colspan="2">
                  <strong>{{ $t("checkout.mark") }}</strong>
                  <textarea
                    class="remark-input"
                    v-model="remarks"
                    :placeholder="$t('checkout.mark-placeholder')"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <strong>{{ $t("checkout.payment_method") }}</strong>
                </td>
                <td class="payment">
                  <v-radio-group class="payment-group" v-model="paymentMethod">
                    <v-radio
                      class="payment-item"
                      :key="index"
                      :label="item.name"
                      :value="item.systemName"
                      v-for="(item, index) in storePayment"
                    >
                      <div slot="label" class="payment-item-label">
                        {{ item.name }}
                      </div>
                    </v-radio>
                  </v-radio-group>
                </td>
              </tr>
              <tr>
                <td v-if="stripeKey && paymentMethod == 'stripe'" colspan="2">
                  <stripe-elements
                    class="stripe-card"
                    ref="elementsRef"
                    :pk="stripeKey"
                    :amount="amount"
                    locale="es"
                    @loading="loading = $event"
                  >
                  </stripe-elements>
                </td>
              </tr>
              <tr>
                <td>
                  <strong class="total">{{ $t("checkout.total") }}</strong>
                </td>
                <td>
                  <strong class="total-price"
                    >€{{ actuallyPaidAmount | fixed(2, true) }}</strong
                  >
                </td>
              </tr>
            </table>

            <div>
              <button
                class="button shadow place-order-button"
                @click="handleSubmit"
                :disabled="!canSubmit"
              >
                <v-progress-circular
                  indeterminate
                  color="white"
                  :size="25"
                  style="margin-right: 20px"
                  v-if="!canSubmit"
                ></v-progress-circular>
                {{ $t("checkout.title") }}
              </button>
            </div>

            <form
              name="from"
              :action="redsysParams.form_action"
              method="POST"
              id="myForm"
            >
              <input
                type="hidden"
                name="Ds_SignatureVersion"
                :value="redsysParams.Ds_SignatureVersion"
              />
              <input
                type="hidden"
                name="Ds_MerchantParameters"
                :value="redsysParams.Ds_MerchantParameters"
              />
              <input
                type="hidden"
                name="Ds_Signature"
                :value="redsysParams.Ds_Signature"
              />
            </form>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import Order from "../../api/order";
import DatePicker from "vue2-datepicker";
import AddressList from "../../components/common/address-list";
import { fixed } from "../../utils";
import moment from "moment";
import { StripeElements } from "vue-stripe-checkout";
import address from "@/api/address";
import "vue2-datepicker/index.css";
const BUSINESS_HOURS_KEY = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
import zh from "vue2-datepicker/locale/zh-cn";
import es from "vue2-datepicker/locale/es";
import de from "vue2-datepicker/locale/de";
import en from "vue2-datepicker/locale/en";

export default {
  components: {
    AddressList,
    StripeElements,
    DatePicker
  },
  data() {
    return {
      languageList: {
        "zh-CN": zh,
        "es-ES": es,
        german: de,
        english: en
      },
      deliveryDate: "",
      paymentMethod: "",
      addressGuid: null,
      deliveryFee: {
        fee: 0
      },
      errorDialog: false,
      tip: "",
      total: 0,
      discount: 0,
      discountAmount: 0,
      actuallyPaidAmount: 0,
      remarks: "",

      canSubmit: true,

      redsysParams: {},

      stripeKey: "",
      amount: 0,
      loading: false,
      token: null,
      charge: null,

      orderGuid: "",
      new_adress_list: [],
      week: "",
      // currentTime: '12:00'
      time24: [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23
      ],
      minute: [],
      chooseHour: -1,
      chooseHourNum: "",
      chooseMinuteNum: "",
      amStartHour: "",
      amStarMinute: "",
      amEndtHour: "",
      amEndMinute: "",
      PmStarHour: "",
      pmStarMinute: "",
      PmEndHour: "",
      pmEndMinute: "",
      timeData: [],
      active_time_hour: "",
      active_time_minute: "",
      dateTimeList: [],
      validDateTimeList: [],
      isShow: true,
      chooseBoxShow: false,
      new_DeliveryFee: "",
      addressList: [],
      adress: [],
      deliveryTime: "",
      businessHoursSetting: {}
    };
  },
  created() {
    this.getBusinessHours2();
    // 当前时间
    this.active_time_hour = new Date().getHours();
    this.active_time_minute = new Date().getMinutes();

    if (this.isLogin) {
      this.getdAddress();
    } else {
      let adress = localStorage.getItem("addressList");
      if (adress != null) {
        this.adress.push(JSON.parse(adress));
        // this.setAddressList(this.adress);
        this.addressList = this.adress;
      } else {
        this.new_adressList = [];
      }
    }
    console.log("添加地址算费,", this.zipCode);
  },
  mounted() {
    this.getStorePayment();
    const payload = {
      items: this.cart.items.map(item => {
        return {
          commodityGuid: item.delivery.guid,
          customerGuid: this.guid,
          quantity: item.num,
          attributes: item.attributes,
          garnish: (item.garnish_items || []).map(item => {
            if (!item.quantity) item.quantity = 1;
            return { ...item };
          })
        };
      }),
      takeType: this.deliveryType == 0 ? "out" : "in"
    };

    this.calculateOrder(payload);
    this.getStoreInfo();
    // this.getdAddress();

    // let chooseTime = sessionStorage.getItem("chooseTime");
    // setTimeout(() => {
    //   if (chooseTime) {
    //     let t = chooseTime.split("-");
    //     this.isShow = false;
    //     this.chooseHourNum = t[0];
    //     this.chooseMinuteNum = t[1];
    //     this.deliveryTime = this.chooseHourNum + ":" + this.chooseMinuteNum;
    //   }
    // }, 500);
  },

  beforeDestroy() {
    if (this.chooseHourNum && this.chooseMinuteNum) {
      sessionStorage.setItem(
        "chooseTime",
        this.chooseHourNum + "-" + this.chooseMinuteNum
      );
    }
  },

  computed: {
    ...mapState([
      "storePayment",
      // "addressList",
      "storeId",
      "language",
      "guid",
      "storeInfo",
      "payAction",
      "isLogin",
      "zipCode",
      "deliveryType"
    ]),
    ...mapGetters(["cart", "getTranslateIndex"]),
    checkedAddress() {
      return this.addressList.find(item => {
        return item.guid === this.addressGuid;
      });
    },
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("breadcrumbs.home")
        },
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("breadcrumbs.delivery_list")
        },
        {
          disabled: true,
          text: this.$t("breadcrumbs.checkout"),
          to: { name: "checkout" }
        }
      ];
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    }
  },
  methods: {
    ...mapMutations(["clearCart", "setDeliveryType"]),
    ...mapActions(["getStorePayment", "getOrderDeliveryFee", "getStoreInfo"]),
    disabledDate(date) {
      if (!date) return false;
      if (new Date().getTime() > new Date(date).getTime() + 24 * 60 * 60 * 1000)
        return true;
      let week = new Date(date).getDay();
      if (!this.businessHoursSetting[BUSINESS_HOURS_KEY[week]]) return true;
      return false;
    },
    disabledTime(date) {
      if (!date) return false;
      if (new Date().getTime() > new Date(date).getTime()) return true;
      let week = new Date(date).getDay();
      let daySetting = this.businessHoursSetting[BUSINESS_HOURS_KEY[week]];
      let curTime = Number(moment(date).format("HHmm"));
      let dur = daySetting.find(item => {
        let startTime = Number(item.startTime.replace(/:/g, ""));
        let endTime = Number(item.endTime.replace(/:/g, ""));
        if (curTime <= endTime && curTime >= startTime) return true;
      });
      if (!dur) return true;
      return false;
    },
    sureDeliveryDate(date, type) {
      if (type === "minute") {
        this.chooseBoxShow = false;
        this.$refs.picker.closePopup();
      }
    },
    async getdAddress() {
      try {
        const {
          data: { isError, data }
        } = await address.loadAddress();

        if (isError) {
          return;
        }
        this.addressList = data;
      } catch (e) {
        console.log(e);
      }
    },
    async redsystransaction(guid) {
      this.canSubmit = false;
      let payload = {
        orderGuid: guid,
        customerLanguage: 1,
        OKUrl: window.location.origin + "/#/order/list",
        UrlKO: window.location.origin + "/#/order/list"
      };
      try {
        const {
          data: { isError, msg, data }
        } = await Order.redsystransaction(payload);

        if (isError) {
          this.tip = msg;
          this.errorDialog = true;
          return;
        }

        this.redsysParams = data;

        setTimeout(() => {
          document.getElementById("myForm").submit();
        }, 1000);
      } catch (e) {
        const {
          response: {
            data: { msg }
          }
        } = e;

        this.errorDialog = true;
        this.tip = msg;
      } finally {
        this.canSubmit = true;
      }
    },

    stripePayAction(orderGuid) {
      this.canSubmit = false;
      this.orderGuid = orderGuid;
      Order.readyToPay({
        orderGuid
      })
        .then(response => {
          this.amount = parseFloat(response.data.data.amount);
          this.$refs.elementsRef.submit();

          const stripe = this.$refs.elementsRef.stripe;
          const card = this.$refs.elementsRef.card;
          const clientSecret = response.data.data.stripeClientSecret;

          if (clientSecret && stripe && card) {
            this.canSubmit = false;

            stripe
              .confirmCardPayment(clientSecret, {
                payment_method: {
                  card: card
                }
              })
              .then(r => {
                if (r.error) {
                  this.$toasted.show(r.error.message);
                  this.canSubmit = true;
                } else {
                  if (r.paymentIntent.status === "succeeded") {
                    this.canSubmit = false;
                    Order.executePay({
                      orderGuid: this.orderGuid,
                      strip_payment_intent_id: r.paymentIntent.id
                    })
                      .then(res => {
                        if (res.data.isError) {
                          this.$toasted.show(res.data.msg);
                        }
                        setTimeout(() => {
                          this.$router.replace({
                            name: "order/detail",
                            query: { show: "createOrderSuccess" },
                            params: { guid: orderGuid }
                          });
                        }, 1000);
                      })
                      .finally(() => {
                        this.canSubmit = true;
                      });
                  }
                }
              })
              .catch(() => {
                this.canSubmit = true;
              });
          }
        })
        .catch(() => {
          this.canSubmit = true;
        });
    },

    async handleSubmit() {
      if (!this.addressList.length) {
        this.$router.push({
          name: "address/create",
          query: { createSuccessRedirectType: "back" }
        });
        return;
      }

      if (!this.addressGuid && this.deliveryType == 0) {
        this.tip = this.$t("checkout.please_choose_address");
        this.errorDialog = true;
        return;
      } else if (!this.checkedAddress.address1 && this.deliveryType == 0) {
        this.tip = this.$t("checkout.please_input_address1");
        this.errorDialog = true;
        return;
      }

      this.canSubmit = false;
      const payload = {
        is_permitir_descuento: 1,
        customerGuid: this.guid,
        deliveryFee: this.deliveryFee.fee,
        deliveryInfo: {
          ...this.checkedAddress
        },
        deliveryTime: this.deliveryDate,
        items: this.cart.items.map(item => {
          return {
            commodityGuid: item.delivery.guid,
            customerGuid: this.guid,
            quantity: item.num,
            attributes: item.attributes,
            garnish:
              item.garnish_items &&
              item.garnish_items.map(it => ({
                // attributes_guid: undefined,
                commodity_guid: it.commodity_guid,
                commodity_name: it.commodity_name,
                commodity_price: it.price,
                price: it.price,
                guid: it.guid
              })),
            remark: item.remark
          };
        }),
        paymentMethod: this.paymentMethod,
        storeGuid: this.storeId,
        remarks: this.remarks,
        clientType: 3,
        takeType: this.deliveryType == 0 ? "out" : "in" //  out 配送到家  in 上门取餐
      };

      try {
        const {
          data: { isError, msg, data }
        } = await Order.createOrder(payload);

        sessionStorage.removeItem("chooseTime");

        if (isError) {
          this.tip = msg;
          this.errorDialog = true;
          return;
        }

        this.clearCart();

        if (payload.paymentMethod == "VisaOnline") {
          this.redsystransaction(data.guid);
        } else if (payload.paymentMethod == "stripe") {
          this.stripePayAction(data.guid);
        } else {
          this.$router.replace({
            name: "order/detail",
            query: { show: "createOrderSuccess" },
            params: { guid: data.guid }
          });
        }
      } catch (e) {
        const {
          response: {
            data: { msg }
          }
        } = e;

        this.errorDialog = true;
        this.tip = msg;
      } finally {
        if (
          payload.paymentMethod != "VisaOnline" &&
          payload.paymentMethod != "stripe"
        ) {
          this.canSubmit = true;
        }
      }
    },
    async getBusinessHours2() {
      let dataBox = {
        storeGuid: ""
      };
      try {
        const {
          data: { isError, data }
        } = await Order.getBusinessHours(dataBox);

        if (isError) {
          return;
        }
        this.businessHoursSetting = data || {};
        let weekDay = new Date().getDay();

        if (weekDay == 1) {
          this.week = data.mon;
        }
        if (weekDay == 2) {
          this.week = data.tue;
        }
        if (weekDay == 3) {
          this.week = data.wed;
        }
        if (weekDay == 4) {
          this.week = data.thu;
        }
        if (weekDay == 5) {
          this.week = data.fri;
        }
        if (weekDay == 6) {
          this.week = data.sat;
        }
        if (weekDay == 0) {
          this.week = data.sun;
        }
        if (this.week.length == 1) {
          this.dataTimeListBuild(
            this.week[0].startHour,
            this.week[0].startMinute,
            this.week[0].endTHour,
            this.week[0].endTMinute
          );
        } else if (this.week.length == 2) {
          this.dataTimeListBuild(
            this.week[0].startHour,
            this.week[0].startMinute,
            this.week[0].endTHour,
            this.week[0].endTMinute
          );
          this.dataTimeListBuild(
            this.week[1].startHour,
            this.week[1].startMinute,
            this.week[1].endTHour,
            this.week[1].endTMinute
          );
        }
        var _d = new Date();
        _d = new Date(_d.valueOf() + 60 * 30 * 1000);
        var nowHours = _d.getHours();
        var nowMinute = _d.getMinutes();
        for (var index in this.dateTimeList) {
          if (this.dateTimeList[index].hour == nowHours) {
            if (nowMinute < 15) {
              this.validDateTimeList.push({
                hour: this.dateTimeList[index].hour,
                minutes: [15, 30, 45]
              });
            } else if (nowMinute < 30) {
              this.validDateTimeList.push({
                hour: this.dateTimeList[index].hour,
                minutes: [30, 45]
              });
            } else if (nowMinute < 45) {
              this.validDateTimeList.push({
                hour: this.dateTimeList[index].hour,
                minutes: [45]
              });
            }
          } else if (this.dateTimeList[index].hour > nowHours) {
            this.validDateTimeList.push(this.dateTimeList[index]);
          }
        }
        this.minute = this.validDateTimeList[0].minutes;
        this.chooseHourNum = this.validDateTimeList[0].hour;
      } catch (e) {
        console.log(e);
      }
    },
    dataTimeListBuild(startHour, startMinute, endTHour, endMinute) {
      var sHour = parseInt(startHour);
      var sMinute = parseInt(startMinute);
      var eHour = parseInt(endTHour);
      var eMinute = parseInt(endMinute);
      // var eTMinute = endTMinute;
      if (startMinute > 45) {
        //开始分钟大于45 直接从下一个小时开始
        sMinute = 0;
        sHour = sHour + 1;
      }
      for (var index in this.dateTimeList) {
        if (this.dateTimeList[index].hour == sHour) {
          //有重复情况 ,单独处理
          if (sMinute > 30) {
            this.dateTimeList[index].minutes.push(45);
          } else if (sMinute > 15) {
            this.dateTimeList[index].minutes.push(30);
            this.dateTimeList[index].minutes.push(45);
          } else if (sMinute > 0) {
            this.dateTimeList[index].minutes.push(15);
            this.dateTimeList[index].minutes.push(30);
            this.dateTimeList[index].minutes.push(45);
          } else if (sMinute == 0) {
            this.dateTimeList[index].minutes.push(0);
            this.dateTimeList[index].minutes.push(15);
            this.dateTimeList[index].minutes.push(30);
            this.dateTimeList[index].minutes.push(45);
          }
          sMinute = 0;
          sHour = sHour + 1;
          break;
        }
      }
      for (var i = sHour; i <= eHour; i++) {
        if (i == sHour) {
          //第一个
          if (sMinute > 30) {
            this.dateTimeList.push({
              hour: i,
              minutes: [45]
            });
          } else if (sMinute > 15) {
            this.dateTimeList.push({
              hour: i,
              minutes: [30, 45]
            });
          } else if (sMinute > 0) {
            this.dateTimeList.push({
              hour: i,
              minutes: [15, 30, 45]
            });
          } else if (sMinute == 0) {
            this.dateTimeList.push({
              hour: i,
              minutes: [0, 15, 30, 45]
            });
          }
        } else if (i == eHour) {
          //最后一个
          if (eMinute < 15) {
            this.dateTimeList.push({
              hour: i,
              minutes: [0]
            });
          } else if (eMinute < 30) {
            this.dateTimeList.push({
              hour: i,
              minutes: [15]
            });
          } else if (eMinute < 45) {
            this.dateTimeList.push({
              hour: i,
              minutes: [15, 30]
            });
          } else if (eMinute > 45) {
            this.dateTimeList.push({
              hour: i,
              minutes: [0, 15, 30, 45]
            });
          }
        } else {
          this.dateTimeList.push({
            hour: i,
            minutes: [0, 15, 30, 45]
          });
        }
      }
    },
    async getBusinessHours() {
      let dataBox = {
        storeGuid: ""
      };
      try {
        const {
          data: { isError, data }
        } = await Order.getBusinessHours(dataBox);

        if (isError) {
          return;
        }
        let weekDay = new Date().getDay();

        if (weekDay == 1) {
          this.week = data.mon;
        }
        if (weekDay == 2) {
          this.week = data.tue;
        }
        if (weekDay == 3) {
          this.week = data.wed;
        }
        if (weekDay == 4) {
          this.week = data.thu;
        }
        if (weekDay == 5) {
          this.week = data.fri;
        }
        if (weekDay == 6) {
          this.week = data.sat;
        }
        if (weekDay == 0) {
          this.week = data.sun;
        }

        if (this.week.length > 1) {
          this.PmStarHour = parseInt(this.week[1].startHour);
          this.pmStarMinute = parseInt(this.week[1].startMinute);
          this.PmEndHour = parseInt(this.week[1].endTHour);
          this.endTMinute = parseInt(this.week[1].endTMinute);
        }
        this.amStartHour = parseInt(this.week[0].startHour);
        this.amStarMinute = parseInt(this.week[0].startMinute);
        this.amEndtHour = parseInt(this.week[0].endTHour);
        this.amEndMinute = parseInt(this.week[0].endTMinute);
        // 填入数据
        // let hour  = new Date().getHours()
        // chooseHour == active_time_hour&&active_time_minute+30>item
        for (var i = 0; i < this.time24.length; i++) {
          if (this.week.length > 1) {
            if (
              this.active_time_hour == this.time24[i] ||
              this.active_time_hour < this.time24[i]
            ) {
              if (
                this.time24[i] >= this.amStartHour &&
                this.time24[i] <= this.amEndtHour
              ) {
                this.timeData.push({ time: this.time24[i], isQuantum: true });
              } else if (
                this.time24[i] >= this.PmStarHour &&
                this.time24[i] <= this.PmEndHour
              ) {
                this.timeData.push({ time: this.time24[i], isQuantum: true });
              } else {
                this.timeData.push({ time: this.time24[i], isQuantum: false });
              }
            }
          }
          if (this.week.length < 2) {
            if (
              this.active_time_hour == this.time24[i] ||
              this.active_time_hour < this.time24[i]
            ) {
              if (
                this.time24[i] >= this.amStartHour &&
                this.time24[i] <= this.amEndtHour
              ) {
                // this.timeData.push({time:this.time24[i], isQuantum:true})
                if (this.active_time_hour == this.time24[i]) {
                  if (this.active_time_minute + 30 >= 30) {
                    this.timeData.push({
                      time: this.time24[i],
                      isQuantum: true,
                      minute: [30, 45]
                    });
                  }
                }
                if (this.active_time_hour + 1 == this.time24[i]) {
                  if (this.active_time_minute + 30 >= 30) {
                    this.timeData.push({
                      time: this.time24[i],
                      isQuantum: true,
                      minute: [30, 45]
                    });
                  }
                }
              } else {
                this.timeData.push({ time: this.time24[i], isQuantum: false });
              }
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getOrderDeliveryFee(payload) {
      try {
        const {
          data: { isError, data }
        } = await Order.getOrderDeliveryFee(payload);

        if (isError) {
          return;
        }

        this.deliveryFee = data;
      } catch (e) {
        console.log(e);
      }
    },
    async calculateOrder(payload) {
      try {
        const {
          data: { isError, data }
        } = await Order.calculateOrder({
          ...payload,
          zipCode: this.checkedAddress && this.checkedAddress.zipcode
        });

        if (isError) {
          return;
        }

        this.total = data.total;
        this.discount = data.discount;
        this.discountAmount = data.discountAmount;
        this.actuallyPaidAmount = data.actuallyPaidAmount;
        this.new_DeliveryFee = data.deliveryFee;
      } catch (e) {
        console.log(e);
      }
    },
    // 切换配送/取餐
    changeDeliveryType(e) {
      this.setDeliveryType(e);
      this.calculateOrder({
        is_permitir_descuento: 1,
        items: this.cart.items.map(item => {
          return {
            commodityGuid: item.delivery.guid,
            customerGuid: this.guid,
            quantity: item.num,
            attributes: item.attributes,
            garnish: (item.garnish_items || []).map(item => {
              if (!item.quantity) item.quantity = 1;
              return { ...item };
            })
          };
        }),
        takeType: this.deliveryType == 0 ? "out" : "in"
      });
    },
    chooseHours(index, time) {
      if (time != "") {
        this.chooseHour = index;
        this.chooseHourNum = time;
        this.minute = this.validDateTimeList[index].minutes;
      }
    },
    chooseMinute(data) {
      let num = String(data);
      if (num == "") {
        this.isShow = true;
        this.deliveryTime = "";
        this.deliveryDate = "";
        console.log("------");
      } else {
        if (num == 0) {
          this.chooseMinuteNum = "0" + num;
        } else {
          this.chooseMinuteNum = num;
        }

        this.deliveryTime = this.chooseHourNum + ":" + this.chooseMinuteNum;
        this.isShow = false;
      }
      this.chooseBoxShow = false;
    },
    chooseBox(data) {
      if (data == true) {
        this.chooseBoxShow = false;
      } else {
        this.chooseBoxShow = true;
      }
    }
  },
  watch: {
    storePayment(value) {
      if (value.length < 0) {
        return;
      }

      const index = value.findIndex(item => {
        return item.systemName === this.paymentMethod;
      });

      if (index > -1) {
        return;
      }

      this.paymentMethod = value[0].systemName;

      if (value) {
        let isHaveStripe = !!value.filter(item => {
          return item.systemName == "stripe";
        }).length;

        if (isHaveStripe) {
          Order.getStripe({}).then(res => {
            if (!res.data.isError) {
              // "pk_test_uHbG9Y8NIvOawb3oV87gZ6FJ00JPv1QXvZ"
              this.stripeKey =
                process.env.NODE_ENV == "production"
                  ? res.data.data.stripe_public_key
                  : "pk_test_uHbG9Y8NIvOawb3oV87gZ6FJ00JPv1QXvZ";
            }
          });
        }
      }
    },
    addressList(value) {
      if (value.length <= 0) {
        return;
      }

      let defaultAddress = value.find(item => {
        return item.defaultAddress;
      });

      if (!defaultAddress) {
        defaultAddress = value[0];
      }

      this.addressGuid = defaultAddress.guid;
    },
    addressGuid() {
      // this.getOrderDeliveryFee({
      //   latitude: this.checkedAddress.latitude,

      //   longitude: this.checkedAddress.longitude,
      //   storeGuid: this.storeId
      // });
      const payload = {
        customerGuid: this.guid,
        // deliveryFee: this.deliveryFee.fee,
        deliveryFee: 0,
        deliveryInfo: {
          ...this.checkedAddress
        },
        deliveryTime: new Date(),
        items: this.cart.items.map(item => {
          return {
            commodityGuid: item.delivery.guid,
            customerGuid: this.guid,
            quantity: item.num,
            attributes: item.attributes,
            garnish: item.garnish || []
          };
        }),
        paymentMethod: this.paymentMethod,
        storeGuid: this.storeId,
        takeType: this.deliveryType == 0 ? "out" : "in"
      };

      this.calculateOrder(payload);
    }
  },
  filters: {
    fixed
  }
};
</script>

<style scoped lang="sass" src="./checkout.sass"></style>
<style scoped lang="sass">
.new_choose_box
    padding: 12px
    background: #f7f7f7
    margin-top: 20px

.new_choose_box .left_box
    float: left
    width: 40%

.new_choose_box .right_box
    width: 60%
    float: left

.selectItem_show_box
    width: 280px
    background: #ffffff
    position: absolute
    z-index: 3
    padding: 12px
    line-height: 30px
    box-shadow: 0 0 10px #676767
    font-weight: bold

.selectItem_show_box .bottom .left_hour
    width: 120px
    float: left
    border-right: 1px solid #f7f7f7
    height: 160px
    overflow: scroll

.selectItem_show_box .bottom .left_hour .hour
    padding-left: 8px

.selectItem_show_box .bottom .left_hour .hour .may_choose:hover
    background: #f7f7f7

.selectItem_show_box .bottom .right_minute
    width: 120px
    float: left
    height: 160px
    padding-left: 12px
    overflow: scroll

.selectItem_show_box .bottom .right_minute .minute:hover
    background: #f7f7f7

.selectItem_show_box .top:hover
    background: #f7f7f7

.may_choose
    color: green

.no_choose
    color: #666666
    cursor: help

.active_may_choose
    background: #f7f7f7

.selectItem_box
    cursor: pointer
    font-weight: bold

.xiala_icon
    float: right
    width: 12px
    margin-right: 20%
    margin-top: 6px
</style>
